import { UserType } from '@/constants/main';

/**
 * UI abilities: key = what you check, value = who can.
 * Usage: `userStore.can(UserAbility.Bet.ViewBookmaker)` or `access: UserAbility.Bet.ViewColumnCommon`.
 *
 * ViewBookmaker — bookmaker name in table/info (agents included).
 * ViewFullBetInfo — internal bookmaker data, admin/company stats (admin/company only).
 */
export const UserAbility = {
    Bet: {
        ViewBetAdminDetails: [UserType.Root, UserType.Admin],
        ViewBetConditions: [UserType.Root, UserType.Admin, UserType.Company, UserType.Agent, UserType.AgentView],
        ExportBets: [UserType.Root, UserType.Admin, UserType.Company, UserType.Agent, UserType.AgentView, UserType.AgentPlatform],

        ViewBookmaker: [UserType.Root, UserType.Admin, UserType.Company, UserType.Agent, UserType.AgentView],
        ViewFullBetInfo: [UserType.Root, UserType.Admin, UserType.Company],

        ViewFilterCommon: [UserType.Root, UserType.Admin, UserType.Company, UserType.Agent, UserType.AgentView, UserType.AgentPlatform],
        ViewColumnCommon: [UserType.Root, UserType.Admin, UserType.Company, UserType.Agent, UserType.AgentView, UserType.AgentPlatform],
        ViewColumnAgentCompany: [UserType.Company, UserType.Agent, UserType.AgentView, UserType.AgentPlatform],
        /** Agent Total (balance + pay comm) — Agent / AgentView only. */
        ViewAgentTotal: [UserType.Agent, UserType.AgentView],
        /** Pay Comm column / pay_com — not AgentPlatform. */
        ViewPayCommission: [UserType.Root, UserType.Admin, UserType.Company, UserType.Agent, UserType.AgentView],
        ViewStatsAgent: [UserType.Agent, UserType.AgentView, UserType.AgentPlatform],
        ViewInfoHistory: [UserType.Root, UserType.Admin, UserType.Company],
        ViewInfoHistoryBalance: [UserType.Company],
    },
} as const;

export type AbilityDefinition = readonly UserType[];
